import { useEffect, useState } from "react";
import { ClipboardCheck, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

function PlanItem({ item, onSaved, locked }) {
  const [note, setNote] = useState(item.note || "");
  const [editing, setEditing] = useState(false);
  const save = async (done) => {
    try { const { data } = await api.post(`/provider/improvement-plan/items/${item.id}`, { done, note }); onSaved(data); setEditing(false); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (item.done && !editing) return (
    <li className="flex gap-2 text-sm" data-testid="plan-item-done"><CheckCircle2 size={18} className="text-emerald-600 shrink-0" />
      <div className="flex-1"><p>{item.text}</p><p className="text-xs muted mt-1 whitespace-pre-line">{item.note}</p></div>
      {!locked && <button onClick={() => save(false)} className="text-xs underline muted" data-testid="plan-item-undo">Undo</button>}</li>
  );
  return (
    <li className="text-sm space-y-2" data-testid="plan-item-open">
      <label className="flex gap-2 items-start"><input type="checkbox" className="mt-1" checked={editing} onChange={(e) => setEditing(e.target.checked)} data-testid="plan-item-check" /><span>{item.text}</span></label>
      {editing && <div className="pl-6 space-y-2"><textarea className="input" rows={2} placeholder="Briefly explain what you've done" value={note} onChange={(e) => setNote(e.target.value)} data-testid="plan-item-note" />
        <button onClick={() => save(true)} disabled={note.trim().length < 10} className="btn-coral btn-sm" data-testid="plan-item-save">Mark as done</button></div>}
    </li>
  );
}

export function ImprovementPlan() {
  const [plan, setPlan] = useState(null);
  useEffect(() => { api.get("/provider/improvement-plan").then((r) => setPlan(r.data)).catch(() => {}); }, []);
  if (!plan) return null;
  const submitted = plan.status === "submitted";
  return (
    <div className="card p-5 mb-5 border-amber-300 bg-amber-50/40" data-testid="improvement-plan">
      <div className="flex gap-3 items-start mb-3"><ClipboardCheck className="text-amber-600 shrink-0" />
        <div><h2 className="font-bold">Your improvement plan ({plan.done}/{plan.total} done)</h2>
          <p className="text-sm muted">New job matches are paused. Complete each step below with a short note, and our team will review it so matches can be switched back on.</p>
          {plan.note && <p className="text-sm mt-2 bg-white border rounded p-2">"{plan.note}"</p>}</div></div>
      {submitted && <p className="text-sm font-semibold text-emerald-700 mb-3" data-testid="plan-submitted">Thanks, all steps are done. Our team is reviewing your plan.</p>}
      <ul className="space-y-3">{plan.items.map((i) => <PlanItem key={i.id} item={i} onSaved={setPlan} locked={submitted} />)}</ul>
    </div>
  );
}
